import React, { useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { InterventionPointProvider, useInterventionPoint } from '../contexts/InterventionPointContext';
import useAnalytics from '../hooks/useAnalytics';
import IPSearchList from '../components/InterventionPoint/IPSearchList';
import IPDetail from '../components/InterventionPoint/IPDetail';

function InterventionPointViewerContent({ currentUser, fetchWithAuth }) {
  const {
    selectedProjet,
    selectedInterventionPoint,
    setSelectedInterventionPoint,
    loadingDetails,
  } = useInterventionPoint();

  const [searchParams] = useSearchParams();
  const jailRef = useRef(searchParams.has('jail'));
  const jail = jailRef.current;

  useAnalytics({ currentUser, project: selectedProjet?.label, module: 'INTERVENTION_POINT_VIEWER' });

  if (selectedInterventionPoint) {
    // Wait for details (CallIDs) to be loaded before rendering the cockpit
    if (loadingDetails || !selectedInterventionPoint.CallIDs) {
      return (
        <div className="flex justify-center py-16">
          <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-500" />
        </div>
      );
    }
    return (
      <IPDetail
        ip={selectedInterventionPoint}
        fetchWithAuth={fetchWithAuth}
        onBack={() => setSelectedInterventionPoint(null)}
      />
    );
  }

  return <IPSearchList jail={jail} onSelect={setSelectedInterventionPoint} />;
}

function InterventionPointViewer({ currentUser, fetchWithAuth }) {
  return (
    <InterventionPointProvider>
      <InterventionPointViewerContent currentUser={currentUser} fetchWithAuth={fetchWithAuth} />
    </InterventionPointProvider>
  );
}

export default InterventionPointViewer;
